// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBNgbzXvgVZxHgyt7vGaOGEaUP5McsKSto",
  authDomain: "zaharaservicios-d7aaf.firebaseapp.com",
  projectId: "zaharaservicios-d7aaf",
  storageBucket: "zaharaservicios-d7aaf.appspot.com",
  messagingSenderId: "803583470567",
  appId: "1:803583470567:web:d38da36e6427a8e7172b42",
  measurementId: "G-P7B8QBHPLY",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
